/**
 * Sequential (weekly) snippet test for /en/.
 *
 * Google does not serve two titles for the same URL at the same time, so a
 * true parallel A/B test is impossible in the SERP. Instead we rotate one
 * variant per ISO week and compare Search Console CTR week over week in the
 * report view. The variant that was live is recorded with every week.
 */

export interface SnippetVariant {
  id: "A" | "B";
  title: string;
  description: string;
}

export const EN_SNIPPET_VARIANTS: SnippetVariant[] = [
  {
    id: "A",
    title: "Barber Near Me, Stockholm | Tailor's Barber, 4 Locations",
    description:
      "Barber near you in Stockholm. Men's haircut 450 SEK, skin fades, beard trims. 4 locations, 1 min from T-Centralen. 4.8 ★. Book online or walk in.",
  },
  {
    id: "B",
    title: "Barber Near Me in Stockholm, Open 7 Days | Tailor's Barber",
    description:
      "English-speaking barbers in Stockholm. Haircut 450 SEK, fades & beard trims. Walk in or book online, 1 min from T-Centralen. 4.8 ★ from 12,000+ reviews.",
  },
];

/** ISO week number, used as the rotation counter. */
export function isoWeek(date: Date): number {
  const d = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
  d.setUTCDate(d.getUTCDate() + 4 - ((d.getUTCDay() + 6) % 7) - 3);
  const firstThursday = new Date(Date.UTC(d.getUTCFullYear(), 0, 4));
  firstThursday.setUTCDate(
    firstThursday.getUTCDate() + 4 - ((firstThursday.getUTCDay() + 6) % 7) - 3,
  );
  return 1 + Math.round((d.getTime() - firstThursday.getTime()) / (7 * 24 * 3600 * 1000));
}

/**
 * Rotation is intentionally disabled while /en/ uses a fixed search snippet.
 * Keep the variants and date helpers so the test can be resumed later.
 */
export function enSnippetVariant(date: Date = new Date()): SnippetVariant {
  void date;
  return EN_SNIPPET_VARIANTS[0];
}

/** Variant that was live for a week starting on `weekStartIso` (YYYY-MM-DD). */
export function variantForWeek(weekStartIso: string): SnippetVariant["id"] {
  return enSnippetVariant(new Date(`${weekStartIso}T00:00:00Z`)).id;
}
